// extracted by mini-css-extract-plugin
export default {"icon":"ReactHoneycombElement_icon__bcnFR","container":"ReactHoneycombElement_container__grYc5"};